<template>
    <div class="container-fluid p-3">
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-column">
                <div class="title d-flex align-items-center">
                    <inline-svg class="me-2" width="36" height="36"
                                src="/assets/img/icons/file-heart-01.svg"></inline-svg>
                    My Card Decks
                </div>
                <div class="subtitle">24 Total Cards</div>
            </div>
            <div class="d-flex flex-column">
                <div>
                    <btn class="btn btn-primary" @click="addCardDeck">
                        <inline-svg class="me-1" src="/assets/img/icons/file-plus-01.svg"></inline-svg>
                        Create a New Card Deck
                    </btn>
                </div>
            </div>
        </div>
        <!--        List of card decks-->
        <card-decks-list @onEditCardDeckItem="handleEditCardDeck"
                         :categoryFilterOptions="categoryFilterOptions"></card-decks-list>
        <modal name="addCardModal"
               :adaptive="true"
               :width="1000" height="auto" :maxWidth="1000"
               :scrollable="true"
               class="pt-3 pb-3"
               :clickToClose="false"
               :keyboard="false"
               @before-open="startTracking"
               @before-close="stopTrackingAndSendEvent"
        >
            <div :class="{loading: loading.closeAddCardModal}">
                <div class="modal-header">
                    <h4 class="modal-title">{{ cardDeck.id ? 'Update Card Deck' : 'Create Card Deck' }}</h4>
                    <button type="button"
                            class="btn-close"
                            data-dismiss="modal"
                            aria-hidden="true"
                            @click="closeAddCardModal">
                    </button>
                </div>
                <div class="divider --top-20"></div>
                <div v-if="step === 1" class="card-modal__body pt-1" style="width: auto">
                    <inline-svg height="32" width="52"
                                src="/assets/img/logo/logo_big_hand_wave_primary.svg"></inline-svg>
                    <div class="card-modal__title">Select a Card Deck Category</div>
                    <div class="card-modal__subtitle">
                        Select a Card Deck category. The category you select will be where the published Card Deck can
                        be found in the Heroes MagnusCards app, and in MagnusTeams.
                    </div>
                    <div class="row mt-3">
                        <div class="col-6 scrollbar-visible" id="v-step-0">
                            <VuePerfectScrollbar style="height: 400px; padding-right: 10px">
                                <div class="card-modal__category-grid">
                                    <a href="#" class="link-black" @click.prevent="selectCategory(category)"
                                       v-for="category in categories">
                                        <category-card-small
                                            :class="{active: category.value === cardDeck.category.value}"
                                            :category="category">
                                        </category-card-small>
                                    </a>
                                </div>
                            </VuePerfectScrollbar>
                        </div>
                        <div class="col-6 d-flex flex-column flex-1">
                            <form-input :v="$v.cardDeck.title"
                                        id="v-step-1"
                                        label="Card Deck Title*"
                                        placeholder="Insert the title of the activity this Card Deck will cover"
                                        v-model="cardDeck.title"/>
                            <label class="text-bold-600" style="margin-top: 24px">Card Deck Cover Image</label>
                            <image-uploader
                                hint="If you don't attach an image here, we will use the image from the first card as your cover."
                                :card_deck_id="cardDeck.id"
                                image_type="deck"
                                :editable="true"
                                upload_link_message="Click to add the Card Deck cover image"
                                v-model="cardDeck.central_image" id="v-step-2">
                            </image-uploader>
                        </div>
                    </div>
                </div>
                <div v-else-if="step === 2" class="card-modal__cards" style="width: auto">
                    <div class="card-modal__title">
                        <inline-svg height="48" src="/assets/img/logo/logo_big_hand_wave_primary.svg"></inline-svg>
                        Add Cards to Your Card Deck
                    </div>
                    <div class="card-modal__subtitle">
                        Each Card is a step in the process. Add a photo and/or description for each Card.
                    </div>
                    <div class="d-flex flex-row gap-3">
                        <div class="d-flex flex-column flex-1" style="min-width: 300px" id="v-step-3">
                            <template v-if="selectedCard">
                                <image-uploader class="pb-2"
                                                hint="If you don’t have a photo, we will use a placeholder image"
                                                image_type="deck"
                                                :editable="true"
                                                style="min-height: 400px"
                                                :card_id="selectedCard.id"
                                                v-model="selectedCard.image">
                                </image-uploader>
                                <form-textarea rows="3" placeholder="Add a short and concise description for this step"
                                               label="Description" v-model="selectedCard.description"/>
                                <div v-if="selectedCard.description.length < 151" class="member-subtitle">{{selectedCard.description.length}}/150 characters used</div>
                                <div v-else class="text-danger">Step content exceeds 150 characters. Please shorten it.</div>
                            </template>
                        </div>
                        <div class="d-flex flex-column pt-1" style="max-height: 550px;">
                            <div class="d-flex flex-column flex-1 pt-1"
                                 style="max-height: 400px; width: 130px; overflow: hidden">
                                <VuePerfectScrollbar id="cardsScrollArea" class="custom-scrollbar">
                                    <draggable
                                        class="list-group p-0"
                                        tag="ul"
                                        v-model="cardDeck.cards"
                                        v-bind="dragOptions"
                                        @start="drag = true"
                                        @end="drag = false"
                                    >
                                        <div :ref="'card' + index" class="card-deck-card"
                                             :class="{'selected': card === selectedCard}"
                                             @click="selectCard(card)"
                                             v-for="(card, index) in cardDeck.cards">
                                            <img v-if="card.image" :src="card.image">
                                            <img v-else src="/assets/img/backgrounds/no-image-background.svg">
                                            <div class="card-deck-card__counter-label floating"
                                                 :class="{'selected': card === selectedCard}">
                                                Card {{ index + 1 }}
                                            </div>
                                            <div v-if="index > 0"
                                                 class="card-deck-card__close-btn"
                                                 :class="{'selected': card === selectedCard}"
                                                 @click.prevent="markCardForDeletion(index)">
                                                <inline-svg src="/assets/img/icons/x-circle.svg"></inline-svg>
                                            </div>
                                        </div>
                                    </draggable>

                                </VuePerfectScrollbar>
                            </div>
                            <div @click.prevent="addCard" class="card-deck-card-add" id="v-step-4">
                                <inline-svg class="mb-1" src="/assets/img/icons/plus-square.svg"></inline-svg>
                                Add Card
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="step === 3" class="modal-body" style="width: auto">
                    <card-deck-preview :cardDeck="cardDeck"></card-deck-preview>
                </div>
                <div class="card-modal__footer mt-3">
                    <div>
                        <span class="counter">Step {{ step }} of 3
                        </span>
                    </div>
                    <div class="d-flex gap-2">
                        <btn v-if="step > 1" class="btn-outline-light btn-lg" @click="previousStep">
                            <inline-svg src="/assets/img/icons/back-icon-md.svg" class="me-1"></inline-svg>
                            Previous
                        </btn>
                        <btn v-if="step !== 3"
                             :loading="loading.save"
                             class="btn-primary btn-lg"
                             :class="{disabled: !(cardDeck.category.value && cardDeck.title)}"
                             @click="nextStep"
                             id="v-step-5">
                            Next
                            <inline-svg src="/assets/img/icons/right-arrow.svg" class="ms-1"></inline-svg>
                        </btn>
                        <btn v-else class="btn-primary btn-lg"
                             id="v-step-6"
                             :loading="loading.save"
                             :disabled="!(cardDeck.category.value && cardDeck.title)"
                             @click="saveCardDeck">
                            {{ cardDeck.id ? 'Update Card Deck' : 'Create Card Deck' }}
                            <inline-svg src="/assets/img/icons/file-heart-01-white.svg" class="ms-1"></inline-svg>
                        </btn>
                    </div>
                </div>
                <v-tour name="onboardingTour" :steps="steps" :options="myOptions"></v-tour>
            </div>
        </modal>
        <modal name="sharingConfirmationModal" height="auto" width="400px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column">
                    <inline-svg src="/assets/img/avatar-group.svg"></inline-svg>
                </div>
                <div class="modal-body">
                    <h4 class="modal-title text-center">Thanks for sharing!</h4>
                    <div class="modal-subtitle-gray text-center">In order to keep our community safe, we will review
                        Card Decks that are shared.
                        <br><br>Don't worry, chances are your Card Deck will be shared within 24 hours.
                    </div>
                </div>
                <div class="divider --top-12"></div>
                <div class="d-flex flex-row justify-content-between gap-2" style="padding: 24px">
                    <btn class="btn-outline-light btn-lg flex-1" @click="$modal.hide('sharingConfirmationModal')">
                        Understood
                    </btn>
                </div>
            </div>
        </modal>
        <modal name="confirmRemoveCardModal" height="auto" width="500px" :scrollable="true">
          <div class="modal-content">
            <div class="modal-header d-flex flex-column">
              <div class="w-100 text-center" style="position: relative">
                <inline-svg class="mb-2" src="/assets/img/icons/alert-triangle-circle.svg"></inline-svg>
                <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                        @click="$modal.hide('confirmRemoveCardModal')"></button>
              </div>
              <h4 class="modal-title">Delete card?</h4>
              <div class="modal-subtitle-gray text-center">You are about to delete a card from this Card Deck. This operation can’t be undone.</div>
            </div>
            <div class="d-flex flex-column gap-2 p-3 mt-2" >
              <div class="d-flex flex-row justify-content-between gap-2">
                <btn class="btn-outline-light btn-lg flex-1"
                     @click="$modal.hide('confirmRemoveCardModal')">
                  Cancel
                </btn>
                <btn class="btn-primary btn-lg flex-1"
                     @click="deleteCard(cardToBeDeletedIndex)">
                  Delete card
                </btn>
              </div>
            </div>
          </div>
        </modal>
        <card-deck-shared-confirmation-modal/>
        <card-deck-collaborations-confirmation-modal/>

        <modal name="cardDeckWorkingModal" height="auto" width="500px" :scrollable="true">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column align-items-start" v-if="workingCaregiver">
                    <div class="w-100" style="position: relative">
                        <inline-svg class="mb-2" src="/assets/img/icons/alert-triangle-circle.svg"></inline-svg>
                        <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                                @click="$modal.hide('cardDeckWorkingModal')"></button>
                    </div>
                    <h4 class="modal-title">Aimee Ng is already working on this card deck.</h4>
<!--                    <div class="modal-subtitle-gray text-center">Do you want to take over?</div>-->
                </div>
                <div class="modal-body d-flex flex-column">
                    <user-avatar :user="workingCaregiver" :displayName="true" subtitle=""/>
                </div>
<!--                <div class="d-flex flex-column gap-2 p-3 mt-2" >-->
<!--                    <div class="d-flex flex-row justify-content-between gap-2">-->
<!--                        <btn class="btn-outline-light btn-lg flex-1"-->
<!--                             @click="$modal.hide('confirmRemoveCardModal')">-->
<!--                            Cancel-->
<!--                        </btn>-->
<!--                        <btn class="btn-primary btn-lg flex-1"-->
<!--                             @click="deleteCard(cardToBeDeletedIndex)">-->
<!--                            Delete card-->
<!--                        </btn>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </modal>
    </div>
</template>

<script>

import {required} from "vuelidate/lib/validators";
import CardDeckPreview from "@/components/CardDeckPreview.vue";
import CardDecksList from "@/views/CardDecks/CardDecksList.vue";
import CategoryCardSmall from "@/components/CategoryCardSmall.vue";
import ImageUploader from "@/components/ImageUploader.vue";
import draggable from 'vuedraggable'
import {mapState} from 'vuex';
import {modelListMixin} from "/src/mixins/modelListMixin.js";
import card from "@/components/Card.vue";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import UserAvatar from "@/components/UserAvatar.vue";
import CardDeckSharedConfirmationModal from "@/views/CardDecks/CardDeckSharedConfirmationModal.vue";
import CardDeckCollaborationsConfirmationModal from "@/views/CardDecks/CardDeckCollaborationsConfirmationModal.vue";

export default {
    name: 'MyCardDecks',
    components: {
        CardDeckSharedConfirmationModal,
        CardDeckCollaborationsConfirmationModal,
        UserAvatar,
        ImageUploader, CategoryCardSmall, CardDecksList, CardDeckPreview, draggable, VuePerfectScrollbar
    },
    mixins: [modelListMixin],
    data() {
        return {
            loading: {
                save: false,
                closeAddCardModal: false,
            },
            cardDeck: {
                title: '',
                category: {},
                central_image: '',
                owner_id: null,
                cards: [
                    {
                        sort_by: 1,
                        description: '',
                        image: null,
                    }
                ]
            },
            selectedCard: {
                image: ''
            },
            cardToBeDeletedIndex: null,
            trackingStartTime: null,
            pingInterval: null,
            workingCaregiver: null,
            step: 1,
            lastStep: 1,
            categories: [],
            filters: {
                status: '',
            },
            categoryFilterOptions: [],
            myOptions: {
                useKeyboardNavigation: false,
                hidePrevious: true,
                labels: {
                    buttonSkip: 'Close Tutorial',
                    buttonPrevious: 'Previous',
                    buttonNext: 'Next',
                    buttonStop: 'Close Tutorial'
                }
            },
            steps: [
                {
                    target: '#v-step-0',  // We're using document.querySelector() under the hood
                    content: this.getTutorialStepContent(0),
                    params: {
                        highlight: true,
                        hidePrevious: true,
                        placement: 'auto'
                    }
                },
                {
                    target: '#v-step-1',
                    content: this.getTutorialStepContent(1),
                    params: {
                        highlight: true,
                        hidePrevious: true,
                        placement: 'auto'
                    }
                },
                {
                    target: '#v-step-2',
                    content: this.getTutorialStepContent(2),
                    params: {
                        highlight: true,
                        placement: 'auto'
                    }
                },
                {
                    target: '#v-step-3',
                    before: () => {
                        return new Promise((resolve) => {
                            this.step = 2; // change the modal screen
                            this.$nextTick(() => { // Wait for the screen to render
                                resolve();
                            });
                        });
                    },
                    content: this.getTutorialStepContent(3),
                    params: {
                        highlight: true,
                        placement: 'auto'
                    }
                },
                {
                    target: '#v-step-4',
                    content: this.getTutorialStepContent(4),
                    params: {
                        highlight: true,
                        placement: 'auto'
                    }
                },
                {
                    target: '#v-step-5',
                    content: this.getTutorialStepContent(5),
                    params: {
                        highlight: true,
                        placement: 'auto'
                    }
                },
                {
                    target: '#v-step-6',
                    before: () => {
                        return new Promise((resolve) => {
                            this.step = 3; // change modal screen
                            this.$nextTick(() => { // Wait for the screen to render
                                resolve();
                            });
                        });
                    },
                    content: this.getTutorialStepContent(6),
                    params: {
                        highlight: true,
                        placement: 'auto'
                    }
                },
            ],
        };
    },
    validations: {
        cardDeck: {
            title: {required: required},
        },
    },
    computed: {
        card() {
            return card
        },
        ...mapState({
            user: (state) => state.user,
        }),
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
                scrollSensitivity: 200,
                forceFallback: true
            };
        }
    },
    created() {
        this.selectedCard = this.cardDeck.cards[0];
    },
    mounted() {
        this.getCategories();
        this.cardDeck.owner_id = this.user.uuid;
        if (this.$route.params.openAddCardDeck) {
            this.$modal.show('addCardModal');
        }
        this.$events.$on('startAddCardDeckTutorial', () => {
            this.addCardDeck();
            setTimeout(() => {
                this.startTour();
            }, 300);
        });
    },
    beforeDestroy() {
        // Clean up the ping interval when component is destroyed
        if (this.pingInterval) {
            clearInterval(this.pingInterval);
            this.pingInterval = null;
        }
    },
    methods: {
        startTour() {
            this.$tours['onboardingTour'].start();
        },
        getCategories() {
            this.$http.get("/category/all")
                .then((res) => {
                    this.categories = res.body.data.categories;
                    this.categoryFilterOptions = res.body.data.categories.slice();
                    this.categoryFilterOptions.unshift({label: 'All Card Decks', value: null});
                })
                .catch((error) => {
                    console.log(error)
                });

        },
        nextStep() {
            this.step++;
        },
        previousStep() {
            this.step--;
        },
        addCardDeck() {
            this.step = 1;
            this.cardDeck = {
                title: '',
                category: {},
                central_image: '',
                owner_id: null,
                cards: [
                    {
                        id: null,
                        sort_by: 1,
                        description: '',
                        image: null,
                    }
                ]
            };
            this.selectedCard = this.cardDeck.cards[0];
            this.$gtag.event('card_deck_create_started', {
              user_id: this.user.uuid,
            });
            this.$modal.show('addCardModal');
        },
        saveCardDeck() {
            this.$v.cardDeck.$touch();
            if (this.$v.cardDeck.$invalid == true) {
                return false;
            }
            this.loading.save = true;
            let url = this.cardDeck.id ? this.cardDeck.deck_copied ? "/deck/clone-deck" : "/deck/update" : "/deck/create";
            this.$http.post(url, this.cardDeck)
                .then((res) => {
                    this.loading.save = false;
                    this.$events.emit('loadMyCardDecks');
                    this.$modal.hide('addCardModal');
                    if (this.cardDeck.id) {
                      this.$gtag.event('card_deck_edited', {
                          deck_id: res.body.data.deck.id,
                      });
                    } else {
                      this.$gtag.event('card_deck_saved', {
                          deck_id: res.body.data.deck.id,
                      });
                    }
                })
                .catch((error) => {
                    this.loading.save = false;
                });
        },
        addCard() {
            const newCard = {
                id: null,
                sort_by: this.cardDeck.cards.length + 1,
                description: '',
                image: '',
            }
            this.cardDeck.cards.push(newCard);
            this.selectedCard = newCard;
            this.$gtag.event('card_added_to_deck', {
                card_deck_title: this.cardDeck.title,
            });

            setTimeout(() => {
                var cardsScrollArea = this.$el.querySelector("#cardsScrollArea");
                cardsScrollArea.scrollTop = cardsScrollArea.scrollHeight;
            })
        },
        markCardForDeletion(index) {
          this.cardToBeDeletedIndex = index;
          this.$modal.show('confirmRemoveCardModal')
        },
        deleteCard(index) {
            this.cardDeck.cards.splice(index, 1);
            this.$modal.hide('confirmRemoveCardModal');
        },
        selectCategory(category) {
            this.cardDeck.category = category;
        },
        selectCard(card) {
            this.selectedCard = card;
        },
        handleEditCardDeck(cardDeck) {
            this.workingCaregiver = null;
            this.$http.post("/deck/working/check", {deck_id: cardDeck.id})
                .then((res) => {
                    console.log(res.data)
                    if (res.data.data.available) {
                        this.step = 1;
                        this.cardDeck = JSON.parse(JSON.stringify(cardDeck));
                        this.selectedCard = this.cardDeck.cards[0];
                        this.$modal.show('addCardModal')
                    }else {
                        this.workingCaregiver = res.data.data.caregiver
                        this.$modal.show('cardDeckWorkingModal');
                    }
                    this.$refs['cardMenu'].tip.hide();
                })
                .catch((error) => {

                });
        },
        closeAddCardModal() {
            if (this.cardDeck.id === undefined) {
                let filePaths = [];
                if (this.cardDeck.central_image) {
                    filePaths.push(this.cardDeck.central_image);
                }
                for (const card of this.cardDeck.cards) {
                    if (card.image) {
                        filePaths.push(card.image);
                    }
                }
                if (!filePaths.length) {
                    this.$modal.hide('addCardModal')
                    return;
                }
                this.loading.closeAddCardModal = true;
                this.$http.post('/delete-files', {filePaths: filePaths})
                    .then((res) => {
                        this.loading.closeAddCardModal = false;
                        this.$modal.hide('addCardModal')
                    })
                    .catch((error) => {
                        this.loading.closeAddCardModal = false;
                        console.log(error)
                    });
            } else {
                this.$modal.hide('addCardModal')
            }
        },
        getTutorialStepContent(step) {
            var title = 'Select a category';
            var subtitle = 'First, select the Card Deck category';
            switch (step) {
                case 1:
                    title = 'Add a title for your Card Deck';
                    subtitle = 'Here you can add a title to your Card Deck. This is mandatory so you can easily search for and find your Card Deck.';
                    break;
                case 2:
                    title = 'Add a Cover Photo';
                    subtitle = 'Upload image from your desktop that describes the Card Deck activity.';
                    break;
                case 3:
                    title = 'Each card is a step in the activity';
                    subtitle = 'Add a photo and a short description for each Card.';
                    break;
                case 4:
                    title = 'You can add more Cards by clicking here';
                    subtitle = 'You can repeat the same process.';
                    break;
                case 5:
                    title = 'Click the “Next” button when you have added all the Cards';
                    subtitle = 'Don’t worry, you can return to this afterwards if you wish.';
                    break;
                case 6:
                    title = 'Review the Card Deck one more time and then click on “Create Card Deck”.';
                    subtitle = 'All set! Now it’s your turn.';
                    break;
            }
            return `<div class="d-flex flex-row">
                    <div>
                        <div class="v-step__step">${step + 1} of 7</div>
                        <div class="v-step__title">${title}</div>
                        <div class="v-step__subtitle">${subtitle}</div>
                    </div>
                    <div style="display: flex; align-items: end; margin-left: 12px">
                        <img width="68px" src="/assets/img/logo/logo_primary_and_white.svg">
                    </div>
                    </div>`
        },
        startTracking() {
            this.trackingStartTime = Date.now();
            this.pingWorkingDeck(true);
            this.pingInterval = setInterval(() => {
                this.pingWorkingDeck(true);
            }, 15000);
        },
        stopTrackingAndSendEvent() {
            const endTime = Date.now();
            const duration = Math.round((Date.now() - this.trackingStartTime) / 1000);
            this.$gtag.event('time_spent_creating_deck', {
              tracked_user_id: this.user.uid,
              time_spent: duration
            });
            this.pingWorkingDeck(false);
            if (this.pingInterval) {
                clearInterval(this.pingInterval);
                this.pingInterval = null;
            }
        },
        pingWorkingDeck(working) {
            this.$http.post("/deck/working/set", {deck_id: this.cardDeck.id, working: working});
        },
    }
};
</script>
